import { useEffect } from "react"

export const useUserActivity = (
  lastActiveTime: number,
  setIsActive: (active: boolean) => void,
  setLastActiveTime: (time: number) => void
) => {
  useEffect(() => {
    const handleUserActivity = () => {
      setLastActiveTime(Date.now())
      setIsActive(true)
    }

    window.addEventListener("mousemove", handleUserActivity)
    window.addEventListener("keydown", handleUserActivity)

    return () => {
      window.removeEventListener("mousemove", handleUserActivity)
      window.removeEventListener("keydown", handleUserActivity)
    }
  }, [setIsActive, setLastActiveTime])

  useEffect(() => {
    const checkInactivity = () => {
      const currentTime = Date.now()
      if (currentTime - lastActiveTime >= 30 * 1000) {
        setIsActive(false)
      }
    }

    const inactivityInterval = setInterval(checkInactivity, 5000)
    return () => clearInterval(inactivityInterval)
  }, [lastActiveTime, setIsActive])
}
